export default __webpack_public_path__ + "static/media/modern-components-light-large.24574bd7.png";